import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { dayChange, filterChange, setPaint, toggleSwitch } from '../../../actions';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import CircularProgress from '@material-ui/core/CircularProgress';

import { _ } from '../../../functions/translator';
import { ColorAttributes, FilterActions, ToggleActions } from '../../../constants/constants';

class ColorTab extends React.Component {

    handlePaintChange = (event) => {
        const paintSelected = event.target.value;
        this.props.setPaint(paintSelected);
        this.props.toggleSwitch(ToggleActions.LEGEND, true);
        this.props.filterChange(FilterActions.CARDS_GROUP_IDS, null);
        this.props.filterChange(FilterActions.IS_DELAYED, false);
        this.props.filterChange(FilterActions.HISTORICAL_OBSERVATIONS, false);
    }

    handleDelayedChange = () => {
        this.props.filterChange(FilterActions.CARDS_GROUP_IDS, null)
        this.props.filterChange(FilterActions.IS_DELAYED, !this.props.isDelayed);
        this.props.filterChange(FilterActions.HISTORICAL_OBSERVATIONS, false);
        if (this.props.paint !== ColorAttributes.DELAYED) {
            this.props.setPaint(ColorAttributes.DELAYED);
        }
    }

    handleStartDateChange = () => {
        this.props.dayChange({
            first: this.props.projectData.days[this.props.projectData.days.length - 7].id, 
            last: this.props.projectData.days[this.props.projectData.days.length - 1].id
        })
        this.props.toggleSwitch(ToggleActions.TIMELINE, true);
    }

    handleHistoricalObservationsChange = () => {
        if (this.props.historicalObservationsLoading) {
            return;
        }
        
        this.props.filterChange(FilterActions.HISTORICAL_OBSERVATIONS, !this.props.historicalObservations);
        this.props.filterChange(FilterActions.IS_DELAYED, false);
        if(!this.props.historicalObservations){
            this.props.filterChange(FilterActions.CARDS_GROUP_IDS, this.props.cardsGroupsWithHistoricalObservations);
        } else {
            this.props.filterChange(FilterActions.CARDS_GROUP_IDS, null);
        }
        if (this.props.paint !== ColorAttributes.HISTORICAL_OBSERVATIONS) {
            this.props.setPaint(ColorAttributes.HISTORICAL_OBSERVATIONS);
        }
    }

    render() {
        return(
            <div
                role="tabpanel"
                hidden={this.props.tabIndex !== this.props.index}
                >
                <FormControl component="fieldset">
                    <p>{_('Color en Base a')}:</p>
                    <RadioGroup className='ml-2 pl-1' value={this.props.paint} onChange={this.handlePaintChange}>
                        <FormControlLabel 
                            value={ColorAttributes.STATUS} 
                            control={<Radio color='primary' size='medium'/>} 
                            label={_('Estado de Protocolo')}
                        />
                        <div className='d-flex justify-content-between'>
                            <FormControlLabel 
                                value={ColorAttributes.DELAYED} 
                                control={<Radio color='primary' size='medium'/>} 
                                label={_('Registro Atrasado')}
                            />
                            <IconButton className='p-1 mt-1 mb-auto eye-button' onClick={this.handleDelayedChange}>
                                {this.props.isDelayed ? <VisibilityOffIcon/> : <VisibilityIcon/>}
                            </IconButton>
                        </div>
                        <FormControlLabel 
                            value={ColorAttributes.PROGRESS} 
                            control={<Radio color='primary' size='medium'/>} 
                            label={_('Avance Físico')}
                        />
                        <FormControlLabel 
                            value={ColorAttributes.CARD_CATEGORY} 
                            control={<Radio color='primary' size='medium'/>} 
                            label={_('Elemento')}
                        />
                        {this.props.userRole.sensitive_data &&
                        <FormControlLabel 
                            value={ColorAttributes.PAID_PHYSICAL_PROGRESS} 
                            control={<Radio color='primary' size='medium'/>} 
                            label={_('Pagado')}
                        />}
                        <div className='d-flex justify-content-between'>
                            {this.props.historicalObservationsLoading ? (
                                <div className='d-flex align-items-center'>
                                    <CircularProgress size={20} color="primary" style={{marginRight: '8px'}} />
                                    <span style={{color: '#9e9e9e', fontSize: '16px'}}>{_('Observaciones Históricas')}</span>
                                </div>
                            ) : (
                                <FormControlLabel 
                                    value={ColorAttributes.HISTORICAL_OBSERVATIONS} 
                                    control={<Radio color='primary' size='medium'/>} 
                                    label={_('Observaciones Históricas')}
                                />
                            )}
                            {!this.props.historicalObservationsLoading && (
                                <IconButton 
                                    className='p-1 mt-1 mb-auto eye-button' 
                                    onClick={this.handleHistoricalObservationsChange}
                                >
                                    {this.props.historicalObservations ? (
                                        <VisibilityOffIcon/>
                                    ) : (
                                        <VisibilityIcon/>
                                    )}
                                </IconButton>
                            )}
                        </div>
                        <FormControlLabel 
                            value={ColorAttributes.DATES} 
                            control={<Radio color='primary' size='medium'/>} 
                            label={_('Fecha de Inicio')}
                            onClick={this.handleStartDateChange}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return { 
        paint: state.paint,
        isDelayed: state.filters.isDelayed,
        historicalObservations: state.filters.historicalObservations,
        historicalObservationsLoading: state.switches.historicalObservationsLoading,
        userRole: state.userRole,
        cardsGroupsWithHistoricalObservations: state.cardsGroupsWithHistoricalObservations,
        projectData : state.projectData
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        setPaint     : setPaint,
        toggleSwitch : toggleSwitch,
        filterChange : filterChange,
        dayChange    : dayChange
    }, dispatch)
}


export default connect(mapStateToProps, matchDispatchToProps)(ColorTab);